export default "__VITE_ASSET__BiK44W_$__"